import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

/** Used to populate single line text for a Tooltip */
const TooltipText = styled(Box)(() => ({
  fontSize: "14px"
}));

export default TooltipText;
